import { fabric } from 'fabric';

class FabricUtils {
  static setup() {
    fabric.perfLimitSizeTotal = 4096 * 1024;
    fabric.maxCacheSideLimit = 8192;
    fabric.Object.prototype.objectCaching = false;
  }

  static loadImage(url, callback, context, crossOrigin) {
    fabric.util.loadImage(
      FabricUtils.imageURL(url),
      callback,
      context,
      crossOrigin,
    );
  }

  static imageURL(url) {
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'fabric=true';
  }

  static getProductFontDivisor(fontSize, prodInfo) {
    const scaleMagicNumber = 0.14; // this magic number, when multiplied by height and ratio yields a divisor that works to scale fonts across various product sizes
    const ratio = prodInfo.get('ratio');
    const inchesHeight = prodInfo.get('printedHeight');

    return scaleMagicNumber * inchesHeight * ratio;
  }

  static productFontScaled(fontSize, prodInfo) {
    //const scaleMagicNumber = 0.164; // good for 10" (before multiplying by ratio)
    //const scaleMagicNumber = 0.140; // good for 5" (before multiplying by ratio)
    const fontDivisor = FabricUtils.getProductFontDivisor(fontSize, prodInfo);
    return fontSize / fontDivisor;
  }

  static productFontUnscaled(scaledFontSize, prodInfo) {
    const fontDivisor = FabricUtils.getProductFontDivisor(
      scaledFontSize,
      prodInfo,
    );
    // The original unscaled font sizes should always be integers, so round just in case of floating point weirdness.
    return Math.round(scaledFontSize * fontDivisor);
  }

  /**
   * Converts the fontSize values between the sizes saved in the VO and the sizes used the Fabric textbox. The sizes
   * saved in the VO are integer values (the values available in the UI font drop down list).
   * @param styles The styles object.
   * @param toFabric Whether to convert from VO to Fabric or vice versa.
   * @param prodInfo The scaling factor is unique to each product size.
   * @returns {*}
   */
  static adjustFontSizes(styles, toFabric, prodInfo) {
    styles = Object.assign({}, styles);

    for (let prop in styles) {
      if (styles.hasOwnProperty(prop)) {
        styles[prop] = Object.assign({}, styles[prop]);
        for (let prop2 in styles[prop]) {
          if (styles[prop].hasOwnProperty(prop2)) {
            const s = Object.assign({}, styles[prop][prop2]);

            if (s.fontSize) {
              if (toFabric) {
                s.fontSize = FabricUtils.productFontScaled(
                  s.fontSize,
                  prodInfo,
                );
              } else {
                s.fontSize = FabricUtils.productFontUnscaled(
                  s.fontSize,
                  prodInfo,
                );
              }
            }
            styles[prop][prop2] = s;
          }
        }
      }
    }

    this.deleteEmptyStyleObjects(styles);
    return styles;
  }

  /**
   * Deletes any empty objects from the styles.
   * When removing styles using , empty objects can be left behind, such as {'0': { '2': {} }, {'3': {}}, etc.
   * @param styles
   */
  static deleteEmptyStyleObjects(styles) {
    for (let prop in styles) {
      if (styles.hasOwnProperty(prop)) {
        styles[prop] = Object.assign({}, styles[prop]);
        for (let prop2 in styles[prop]) {
          if (styles[prop].hasOwnProperty(prop2)) {
            const s = Object.assign({}, styles[prop][prop2]);

            if (JSON.stringify(s) === '{}') {
              delete styles[prop][prop2];
            }
          }
        }
      }
    }

    // Now that we've deleted nested empty objects, we may have empty top-level objects, so delete those too.
    for (let prop in styles) {
      if (styles.hasOwnProperty(prop)) {
        if (JSON.stringify(styles[prop]) === '{}') {
          delete styles[prop];
        }
      }
    }
  }
}

export default FabricUtils;
